import axios from '../Axios/Default';
import { handleResponse } from '../Utils/Utils';

export const getComMapAll = (_params, onSuccess, onError) => {
    const response = axios.get('v1/admin/competitor/map', { params: _params });
    return handleResponse(response, onSuccess, onError);
};

export const getComMapById = (id, onSuccess, onError) => {
    const response = axios.get(`v1/admin/competitor/map/${id}`);
    return handleResponse(response, onSuccess, onError);
};

export const createComMap = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/admin/competitor/map`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const updateComMap = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/competitor/map/${id}`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const inActiveComMap = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/competitor/map/${id}/inactive`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const softDeleteComMap = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/competitor/map/${id}/delete`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const deleteComMap = (id, onSuccess, onError) => {
    const response = axios.delete(`v1/admin/competitor/map/${id}`);
    return handleResponse(response, onSuccess, onError);
};